var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup161(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(-1396 -3175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 67,
    height: 67,
    rx: 15,
    transform: "translate(1396 3175)",
    fill: "#f6f6fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(1424.487 3189.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M190.906,10.881H184.3l-.257-.724A5.873,5.873,0,0,0,180,6.583V0l1.3.265a11.916,11.916,0,0,1,9.337,9.311Z",
    transform: "translate(-180 -0.001)",
    fill: "#6aa9ff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M6.528,11.969c0-4.3,4.326-5.368,4.352-5.387V0l-1.3.265A11.943,11.943,0,0,0,3.509,20.428l4.071-.988.543-3.626A5.423,5.423,0,0,1,6.528,11.969Z",
    transform: "translate(1411.431 3189.43)",
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M68.833,180l-.265,1.3A11.964,11.964,0,0,1,48.38,187.37l4.614-4.614a5.423,5.423,0,0,0,3.845,1.6c4.4,0,5.3-4.228,5.387-4.352Z",
    transform: "translate(1366.56 3022.489)",
    fill: "#ffe470"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M176.994,180l-.265,1.3A11.978,11.978,0,0,1,165,190.879v-6.528c4.4,0,5.3-4.228,5.387-4.352Z",
    transform: "translate(1258.399 3022.489)",
    fill: "#ffb64c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M391,242h6.528v18.5H391Z",
    transform: "translate(1048.792 2964.986)",
    fill: "#ffb64c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M271,392h6.528v7.616H271Z",
    transform: "translate(1160.088 2825.866)",
    fill: "#6aa9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M151,362h6.528v9.792H151Z",
    transform: "translate(1271.384 2853.69)",
    fill: "#ffe470"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M31,422h6.528v5.44H31Z",
    transform: "translate(1382.679 2798.042)",
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(1411.431 3224.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M0,482H37.139v2.176H0Z",
    transform: "translate(0 -481.999)",
    fill: "#61729b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M256,482h18.569v2.176H256Z",
    transform: "translate(1174 2742.395)",
    fill: "#47568c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup161);
export default __webpack_public_path__ + "static/media/Group 161.27e33011e798fd79a7da315ae9e6ef24.svg";
export { ForwardRef as ReactComponent };